import React from 'react';
import { P } from 'components/reusable-css';
import * as Styles from '../style';
import { Icon } from 'semantic-ui-react';
import { Formik } from 'formik';
import { addNewRuleInitial, addNewRuleValidationSchema, ALL, INPUT, OBJECT_DROPDOWN, PORT_DROPDOWN } from '../utils';
import { useTranslation } from 'react-i18next';
import RuleForm from './RuleForm';

const AddRuleForm = ({ setIndexx, rules, setRuleSetArr, firewallServies, insertIndex, uniqueProtocol, objectArr }) => {
  const { t } = useTranslation();
  const handleClose = () => setIndexx('');
  const handleAddRule = (values, resetForm) => {
    const newObject = {
      order: -1, // temporary, will fix below
      enabled: values.enabled,
      action: values.action,
      protocol: values.protocol,
      //src
      src: values.src_checkbox === ALL ? ALL : values.src_checkbox === INPUT ? values.src_ip_input : '',
      src_object: values.src_checkbox === OBJECT_DROPDOWN ? values.src_object_dropdown : '',
      //dst ip
      dst_ip: values.dst_ip_checkbox === ALL ? ALL : values.dst_ip_checkbox === INPUT ? values.dst_ip_input : '',
      dst_ip_object: values.dst_ip_checkbox === OBJECT_DROPDOWN ? values.dst_ip_object_dropdown : '',
      // dst service
      dst_service:
        values.dst_service_checkbox === ALL
          ? ALL
          : values.dst_service_checkbox === PORT_DROPDOWN
          ? values.dst_service_dropdown
          : values.dst_service_checkbox === INPUT
          ? values.dst_service_input
          : '',
      dst_service_object: values.dst_service_checkbox === OBJECT_DROPDOWN ? values.dst_service_object_dropdown : '',
    };

    setRuleSetArr((prev) => {
      const newArr = [...prev];

      // if no index passed, insert at end
      const position = insertIndex !== undefined ? insertIndex + 1 : newArr.length;

      // insert new object at chosen position
      newArr.splice(position, 0, newObject);

      // reassign sequential order values
      return newArr.map((item, i) => ({ ...item, order: i + 1 }));
    });

    setIndexx('');
    resetForm();
  };

  const handlePortArr = (values) => {
    let isArray = [];
    if (values.value == 'all') {
      isArray = firewallServies?.network_services?.sort((a, b) => Number(b.priority) - Number(a.priority)); // rearrange by priority
    } else {
      isArray = firewallServies?.network_services
        ?.filter((data) => data.protocol === values.value)
        ?.sort((a, b) => Number(b.priority) - Number(a.priority)); // rearrange by priority
    }

    const portData = isArray?.map((data) => {
      return { text: `${data.id} (${data.service})`, value: data.id };
    });

    return portData;
  };

  return (
    <Styles.RulesContainer>
      <Styles.AddRuleText>
        <Styles.AddNewRuleSty>
          <Icon name="add" />
          <P>{t('vs/firewall.string26', { order: rules.length + 1 })}</P>{' '}
        </Styles.AddNewRuleSty>
        <P>{t('vs/firewall.string27')}</P>
      </Styles.AddRuleText>
      <Styles.FormWrapper>
        <Styles.CloseContainer>
          <Icon name="close" onClick={handleClose} />
        </Styles.CloseContainer>
        <Formik
          initialValues={addNewRuleInitial(uniqueProtocol, handlePortArr(uniqueProtocol[0]))}
          validationSchema={addNewRuleValidationSchema}
          onSubmit={(values, { resetForm }) => handleAddRule(values, resetForm)}
        >
          {(formik) => (
            <RuleForm
              objectArr={objectArr}
              formik={formik}
              firewallServies={firewallServies}
              uniqueProtocol={uniqueProtocol}
            />
          )}
        </Formik>
      </Styles.FormWrapper>
    </Styles.RulesContainer>
  );
};

export default AddRuleForm;
